<template>
  <div class="app-container">
    <div class="top_btns clearfix">
      <div class="left_box">
        <search @success="getList">
          <el-form style="margin:11px 0px 0px 0px;width:430px" class="styleForm">
            <el-form-item label="选择期间 ：" :label-width="formLabelWidth" class="dateFormPeriod" prop="period">
              <qzf-period v-model:period="listQuery.period"></qzf-period>
            </el-form-item>
            <!-- <el-form-item label="会计期间 ：" :label-width="formLabelWidth">   
              <qzf-period v-model:period="listQuery.beginTime"></qzf-period>
              <span>-</span>
              <qzf-period v-model:period="listQuery.endTime"></qzf-period>
            </el-form-item> -->
            <el-form-item label="会计期间 ：" :label-width="formLabelWidth">
              <el-date-picker size="mini" v-model="listQuery.beginTime" type="month" placeholder="请选择账期" value-format="YYYYMM" format="YYYYMM"></el-date-picker> 
              <span>-</span>
              <el-date-picker size="mini" v-model="listQuery.endTime" type="month" placeholder="请选择账期" value-format="YYYYMM" format="YYYYMM"></el-date-picker> 
            </el-form-item>
            <el-form-item label="选择级别 ：" :label-width="formLabelWidth">
              <el-input placeholder="1" style="width: 90px;" class="filter-item" size="mini" :disabled="true" />
              <span>-</span>
              <el-input placeholder="请输入级别" v-model.number="listQuery.level" style="width: 90px;margin-right:10px" class="filter-item" size="mini" />
            </el-form-item>
            <!-- <el-form-item label="科目名称 ：" :label-width="formLabelWidth"> 
              <el-input size="mini" v-model="listQuery.name" style="width:60%"></el-input>
            </el-form-item> -->
            <el-form-item label-width="42px" style="height:10px"> 
              <el-checkbox v-model="listQuery.not0" label="余额为0不显示"></el-checkbox>
            </el-form-item>
          </el-form>
        </search>
      </div>
      <div class="right_box">
        <el-dropdown>
          <qzf-button jz="false" button_code="zb_zz_gd" type="primary" size="mini">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </qzf-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item><qzf-button jz="false" button_code="zb_zz_dya4h" @click="printing()" type="success" size="mini" plain>打印</qzf-button></el-dropdown-item>
              <el-dropdown-item><qzf-button jz="false" button_code="zb_zz_dc" @click="daochu()" type="info" size="mini" plain>导出</qzf-button></el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <el-table :height="contentStyleObj" size="mini" :header-cell-style="{background: '#eee',color:'#333','font-size': '13px'}" v-loading="listLoading" :key="tableKey" :data="seachlist" border fit highlight-current-row @sort-change="sortChange" style="width: 100%">
      <el-table-column label="科目编码" align="center">
        <template #default="scope">
          <span class="bianma" @click="gotoDetail(scope.row.subjectCode)">{{scope.row.subjectCode}}</span>
        </template>
      </el-table-column>
      <el-table-column label="科目名称" align="center">
        <template #default="scope">
          <span>{{scope.row.subjectName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="期间" align="center">
        <template #default="scope">
          <div class="div_p" v-for="(item,index) in scope.row.item" :key="index">
            <p>{{item.period}}</p>
            <p>{{item.period}}</p>
            <p>{{item.period}}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="摘要" align="center">
        <template #default="scope">
          <div class="div_p" v-for="(item,index) in scope.row.item" :key="index">
            <p>期初余额</p>
            <p>本期合计</p>
            <p>本年累计</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="借方" align="center">
        <template #default="scope">
          <div class="div_p" v-for="(item,index) in scope.row.item" :key="index">
            <p>{{item.periodBeginIn}}</p>
            <p>{{item.periodInt}}</p>
            <p>{{item.yearInt}}</p>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="贷方" align="center">
        <template #default="scope">
          <div class="div_p" v-for="(item,index) in scope.row.item" :key="index">
            <p>{{item.periodBeginOut}}</p>
            <p>{{item.periodOut}}</p>
            <p>{{item.yearOut}}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="余额" align="center">
        <template #default="scope">
          <div class="div_p" v-for="(item,index) in scope.row.item" :key="index">
            <p>{{item.endAmount1}}</p>
            <p>{{item.endAmount2}}</p>
            <p>{{item.endAmount3}}</p>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- <printVouch ref="printVouch" name="book_all_account" :listQuery1="this.listQuery"></printVouch>
    <exportFile ref="exportFile" name="book_all_account" :listQuery1="this.listQuery"></exportFile> -->
  </div>
</template>

<script>
import { allAccountListNew } from "@/api/old.js"
// import printVouch from "./printVouch.vue"
// import exportFile from "./exportFile.vue"
export default {
  name:'allaccounthis',
  // components: {
  //   printVouch,
  //   exportFile
  // },
  data() {
    return {
      contentStyleObj:{}, //高度变化
      formLabelWidth: '120px',
      seachlist: [],
      list: null,
      listLoading: false,
      listQuery: {
        comId: this.$store.getters['user/comInfo'].comId*1,
        period: this.$store.getters['user/comInfo'].period,
        not0: false,
        name: '',
        level: 1,
        beginTime:'',
        endTime:''
      },
    }
  },
  created() {
    this.contentStyleObj= this.$getHeight(200)
    this.getList()
  },
  watch: {

  },
  methods: {
    // printing() {
    //   this.$refs.printVouch.init()
    // },
    // daochu(){
    //   this.$refs.exportFile.init()
    // },
    getList() {
      // this.listLoading = true;
      allAccountListNew(this.listQuery).then(res => {
        this.listLoading = false;
        if(!res.data.data.list){
          res.data.data.list = []
        }
        let list = res.data.data.list;
        list.map(item=>{
          item.item.map(v=>{
            v.endAmount1 = v.beginType + " " + v.endAmount1
            v.endAmount2 = v.periodType + " " + v.endAmount2
            v.endAmount3 = v.endType + " " + v.endAmount3
          })
        })
        this.seachlist = list;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.searchGjz {
  border: 1px solid #ebeef5;
}
.searchBtn {
  text-align: center;
  button {
    margin-right: 5px;
    padding: 10px 0 10px 0;
  }
}
.top_btns {
  margin-bottom: 20px;
  .left_box{
    float: left;
    width: 70%;
  }
  .right_box {
    float: right;
    width: 30%;
    text-align: right;
  }
}
</style>